import {Button, Grid} from '@mui/material';
import {useTranslation} from 'react-i18next';

interface FilterButtonProps {
  onClick: () => void;
  documentType: string;
  filterVisible: boolean;
}

const FilterButton: React.FC<FilterButtonProps> = ({
  onClick,
  documentType,
  filterVisible
}) => {
  const {t} = useTranslation();

  const translatedDocumentType = t(documentType);

  return (
    <Grid
      container
      alignItems="center"
      justifyContent={{xs: 'center', sm: 'flex-end'}}
    >
      <Button
        variant="contained"
        color={filterVisible ? 'primary' : 'secondary'}
        onClick={onClick}
      >
        {filterVisible
          ? t('close')
          : t('to_filter', {documentType: translatedDocumentType})}
      </Button>
    </Grid>
  );
};

export default FilterButton;
